module.exports = __webpack_public_path__ + "static/media/heart-black.4c596bd2.svg";